<template>
  <div class="main">
    <img class="not_banner"
         src="../../assets/img/pay/orderSuccess.png" />
    <div class="centent_img">
      <p class="text1">
        <span class="num">88</span>
        <span class="text">元保一年</span>
      </p>
      <div class="text2">
        最高400万医疗保障
      </div>
      
      <div class="tipdiv">
        <div class="tipbox">
          <div style="text-align: left;">
            <span class="tip1">官方指定参保平台</span>
            <span class="tip2">【巴陵e惠保】微信公众号</span>
          </div>
          <div class="imgbox">
            <img src="../../assets/img/pay/pai.png" alt="">
          </div>
        </div>
        <div class="wechatCode">

        </div>
      </div>
      <div class="textTip">
        长按识别二维码关注公众号
      </div>
    </div>

  </div>
</template>


<script>
import { getDeviceInfo } from '@/util/tools'
import { SetLeChengShare } from '@/util/set-wx-share'
export default {
  name: 'BuySuccess',
  components: {},
  filters: {},
  mixins: [],
  props: {},
  data() {
    return {
      payType: '',
      show: false,
      platInfo: getDeviceInfo()
    }
  },
  computed: {},
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        if (newVal.fullPath !== oldVal.fllPath) {
          this.initPage()
        }
      }
    }
  },
  created() {},
  mounted() {
    this.payType = this.$route.query.payType
    if (this.payType === 'alipayAcc') { // 支付方式为支付宝时做埋点
      // eslint-disable-next-line no-undef
      __bl.api({ api: "成功投保", success: true, c1: "taSR_YL", time: 0 })
      // eslint-disable-next-line no-undef
      // __bl.api({api:"成功投保",success:true,c1:"taSR_YL"})
    }
    this.initPage()
  },
  destroyed() {
    sessionStorage.removeItem('buySuccess')
  },
  methods: {
    async initPage() {
      SetLeChengShare()
    },
    toJoin(){
      this.$router.push({
        path: '/area-insu-buy-detail',
        query: {
          fromSourceCode: this.$route.query.fromSourceCode,
          baosicode: this.$route.query.baosicode,
        }  
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.wxqrcode {
  margin-top: 8vh;
  display: flex;
  font-size: 3vw;
  img {
    width: 60%;
  }
  dd,
  p {
    margin: 0px;
  }
  dt img {
    width: 64.4%;
  }
}
.stateP {
  color: #000;
  font-size: 14px;
  line-height: 30px;
  text-align: left;
}
.not_banner {
  width: 100%;
}
.centent_img {
  text-align: center;
  padding: 0px 6vw;
  font-size: pxrem(28);
  line-height: pxrem(60);
  color: #000;
  .text1{
    .num{
    font-size: 50px;
    font-weight: bold;
    color: #EA332B;
    }
    .text{
      font-size: 22px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 40px;
    }
  }
  .text2{
   font-size: 19px;
    font-weight: bold;
    color: #EA332B;
    line-height: 33px;
    background: #FFF1F1;
    width: 58%;
    margin: xvw(9) auto xvw(27);
  }
  .flexbox{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    .flexlist{
      margin-top: 8px;
      img{
        width:26px;
        vertical-align: sub;
      }
    }
  }
  .tipdiv{
    background: #FFF1F1;
    border-radius: 12px;
    padding: 12px;
    .tipbox{
      display: flex;
      justify-content: space-between;
      .tip1{
        font-size: 22px;
        color: #730D07;
        line-height: 30px;
        letter-spacing: 2px;
        font-weight: bold;
      }
      .tip2{
        font-size: 18px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #730D07;
        line-height: 50px;
        letter-spacing: 1px;
        display: inline-block;
      }
      .imgbox{
        width: 110px;
        img{
          width: 100%;
        }
      }
    }
    .wechatCode{
      width: xvw(228);
      height: xvw(228);
    }
  }
  .textTip{
      text-align: center;
      font-size: xvw(32);
      font-weight: 500;
      color: #D8D8D8;
      line-height: 48px;
      letter-spacing: 1px;
      background: linear-gradient(360deg, #EA332B 0%, #FF5A24 100%);
      -webkit-background-clip:text; 
      -webkit-text-fill-color:transparent; 
    }
  .but{
    height: px2rem(120);
    background: linear-gradient(to right, #FF7828 , #FF282C);;
    border-radius:  px2rem(60);
    border-color: #EDEEF2;
  }
}
</style>
